module.exports = __webpack_public_path__ + "static/media/logo.6371728b.png";